export default "__VITE_ASSET__CK7_F1jC__"